import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./securityReviewSubmission.html";
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { navigate, SECURITY_REVIEW_EDITOR_ROUTE } from '~/modules/stores/routerStore';
import { images } from '~/modules/utilities/assetUtilities';
import { generateKeyForIterable } from '~/modules/utilities/browserUtilities';
import { formatDate } from '~/modules/utilities/dateUtilities';
import { upsertQueryParam, upsertQueryParams } from '~/modules/utilities/routingUtilities';
import { isApiSolutionType } from '~/modules/utilities/schemaUtilities';
import { OpsSecurityOpsReviewStatus, PartnerSecurityReviewStatus } from '~/modules/utilities/securityReviewUtilities';
import { canResubmit } from '~/modules/utilities/solutionUtilities';
class SecurityReviewSubmission extends LightningElement {
  constructor(...args) {
    super(...args);
    this.images = images;
    this.srStatus = void 0;
    this.opsStatus = void 0;
    this.srDate = void 0;
    this.submissionCount = 1;
    this.feedbackItem = void 0;
    this.challengeRaised = false;
    this.challenge = void 0;
    this.partnerWaitingReason = void 0;
    this.hasFalsePositiveDocument = false;
    this.solutionTechnology = void 0;
    this.solution = void 0;
    this.labels = {};
    this.sharedLabels = {};
    this.stepLabels = {};
    this.STATUS_DATA = {
      [OpsSecurityOpsReviewStatus.new]: labels => ({
        iconClass: 'normal',
        iconName: 'utility:info_alt',
        styleClass: 'submitted-text submitted slds-p-left--x-small ',
        submittedDateText: labels.submitted
      }),
      [OpsSecurityOpsReviewStatus.processingOps]: labels => ({
        iconClass: 'normal',
        iconName: 'utility:info_alt',
        styleClass: 'submitted-text submitted slds-p-left--x-small ',
        submittedDateText: labels.submitted
      }),
      [OpsSecurityOpsReviewStatus.returnedOps]: labels => ({
        iconClass: 'returned',
        iconName: 'standard:contact_request',
        styleClass: 'submitted-text slds-p-left--x-small returned',
        submittedDateText: labels.returned
      }),
      [OpsSecurityOpsReviewStatus.inReviewProdSec]: labels => ({
        iconClass: 'normal',
        iconName: 'utility:info_alt',
        styleClass: 'submitted-text submitted slds-p-left--x-small ',
        submittedDateText: labels.submitted
      }),
      [OpsSecurityOpsReviewStatus.returnedProdSec]: labels => ({
        iconClass: 'returned',
        iconName: 'standard:contact_request',
        styleClass: 'submitted-text slds-p-left--x-small returned',
        submittedDateText: labels.returned
      }),
      [OpsSecurityOpsReviewStatus.expired]: labels => ({
        iconClass: 'error',
        iconName: 'utility:error',
        styleClass: 'submitted-text slds-p-left--x-small failed',
        submittedDateText: labels.expired
      }),
      [OpsSecurityOpsReviewStatus.pass]: labels => ({
        iconClass: 'success',
        iconName: 'utility:success',
        styleClass: 'submitted-text slds-p-left--x-small passed',
        submittedDateText: labels.approved
      }),
      [OpsSecurityOpsReviewStatus.failedTest]: labels => ({
        iconClass: 'error',
        iconName: 'utility:error',
        styleClass: 'submitted-text slds-p-left--x-small failed',
        submittedDateText: labels.failed
      })
    };
  }
  i18nCallback(i18n) {
    this.sharedLabels = i18n.shared;
    this.labels = i18n.securityReviewSubmission;
    this.stepLabels = i18n.srwStep;
  }
  get iconName() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      var _this$STATUS_DATA$thi, _this$STATUS_DATA$thi2, _this$STATUS_DATA, _this$STATUS_DATA$thi3;
      return (_this$STATUS_DATA$thi = (_this$STATUS_DATA$thi2 = (_this$STATUS_DATA = this.STATUS_DATA)[this.opsStatus]) === null || _this$STATUS_DATA$thi2 === void 0 ? void 0 : (_this$STATUS_DATA$thi3 = _this$STATUS_DATA$thi2.call(_this$STATUS_DATA, this.labels)) === null || _this$STATUS_DATA$thi3 === void 0 ? void 0 : _this$STATUS_DATA$thi3.iconName) !== null && _this$STATUS_DATA$thi !== void 0 ? _this$STATUS_DATA$thi : '';
    }
    return '';
  }
  get styleClass() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      var _this$STATUS_DATA$thi4, _this$STATUS_DATA$thi5, _this$STATUS_DATA2, _this$STATUS_DATA$thi6;
      return (_this$STATUS_DATA$thi4 = (_this$STATUS_DATA$thi5 = (_this$STATUS_DATA2 = this.STATUS_DATA)[this.opsStatus]) === null || _this$STATUS_DATA$thi5 === void 0 ? void 0 : (_this$STATUS_DATA$thi6 = _this$STATUS_DATA$thi5.call(_this$STATUS_DATA2, this.labels)) === null || _this$STATUS_DATA$thi6 === void 0 ? void 0 : _this$STATUS_DATA$thi6.styleClass) !== null && _this$STATUS_DATA$thi4 !== void 0 ? _this$STATUS_DATA$thi4 : '';
    }
    return '';
  }
  get iconClass() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      var _this$STATUS_DATA$thi7, _this$STATUS_DATA$thi8, _this$STATUS_DATA3, _this$STATUS_DATA$thi9;
      return (_this$STATUS_DATA$thi7 = (_this$STATUS_DATA$thi8 = (_this$STATUS_DATA3 = this.STATUS_DATA)[this.opsStatus]) === null || _this$STATUS_DATA$thi8 === void 0 ? void 0 : (_this$STATUS_DATA$thi9 = _this$STATUS_DATA$thi8.call(_this$STATUS_DATA3, this.labels)) === null || _this$STATUS_DATA$thi9 === void 0 ? void 0 : _this$STATUS_DATA$thi9.iconClass) !== null && _this$STATUS_DATA$thi7 !== void 0 ? _this$STATUS_DATA$thi7 : '';
    }
    return '';
  }
  get submittedDateText() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      var _this$STATUS_DATA$thi10, _this$STATUS_DATA$thi11, _this$STATUS_DATA4, _this$STATUS_DATA$thi12;
      return (_this$STATUS_DATA$thi10 = (_this$STATUS_DATA$thi11 = (_this$STATUS_DATA4 = this.STATUS_DATA)[this.opsStatus]) === null || _this$STATUS_DATA$thi11 === void 0 ? void 0 : (_this$STATUS_DATA$thi12 = _this$STATUS_DATA$thi11.call(_this$STATUS_DATA4, this.labels)) === null || _this$STATUS_DATA$thi12 === void 0 ? void 0 : _this$STATUS_DATA$thi12.submittedDateText) !== null && _this$STATUS_DATA$thi10 !== void 0 ? _this$STATUS_DATA$thi10 : '';
    }
    return '';
  }
  get whatWillHappenTitleByStatus() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      if (this.opsStatus === OpsSecurityOpsReviewStatus.expired || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec || this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.processingOps || this.opsStatus === OpsSecurityOpsReviewStatus.failedTest) {
        return this.labels.whatHappensNext;
      }
    }
    return this.labels.whatWillHappenNow;
  }
  get whatWillHappenNowSubtitleByStatus() {
    if (this.showWaitingOnPartner) {
      return this.labels.whatWillHappenNowWaitingOnPartner;
    }
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      if (this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec) {
        return this.labels.whatWillHappenNowReturned;
      } else if (this.opsStatus === OpsSecurityOpsReviewStatus.inReviewProdSec) {
        return this.labels.whatWillHappenNowInReviewProdSec;
      } else if (this.opsStatus === OpsSecurityOpsReviewStatus.failedTest) {
        return this.labels.whatWillHappenNowFailed;
      } else if (this.opsStatus === OpsSecurityOpsReviewStatus.expired) {
        return this.labels.submitedExpiredSubtitle;
      }
    }
    return this.labels.whatWillHappenNowDefault;
  }
  get subtitleSubmittedWith() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      if (this.srStatus === PartnerSecurityReviewStatus.reSubmitted && this.opsStatus === OpsSecurityOpsReviewStatus.processingOps) {
        return this.labels.resubmittedWithOps;
      } else if (this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec) {
        return this.labels.returnedProdSec;
      } else if (this.opsStatus === OpsSecurityOpsReviewStatus.inReviewProdSec) {
        return this.labels.submittedWithProdSec;
      } else if (this.opsStatus === OpsSecurityOpsReviewStatus.failedTest) {
        return this.labels.waitingOnActions;
      } else if (this.opsStatus === OpsSecurityOpsReviewStatus.expired) {
        return this.labels.expiredSecurityReview;
      }
    }
    return this.labels.submittedWithOps;
  }
  get showWaitingOnPartner() {
    return this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec && this.partnerWaitingReason != null;
  }
  get showOppties() {
    return (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) && (this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec || this.opsStatus === OpsSecurityOpsReviewStatus.failedTest);
  }
  get statusFailed() {
    return this.opsStatus === OpsSecurityOpsReviewStatus.failedTest;
  }
  get statusApproved() {
    return this.opsStatus === OpsSecurityOpsReviewStatus.pass;
  }
  get statusReturnedProdSec() {
    return this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec;
  }
  get bookOfficeHour() {
    if (this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec) {
      return this.labels.bookNonTechnicalOfficeHour;
    } else if (this.opsStatus === OpsSecurityOpsReviewStatus.failedTest) {
      return this.labels.bookTechnicalOfficeHour;
    }
    return '';
  }
  get bookOfficeHourLink() {
    if (this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec) {
      return this.labels.scheduleNonTechOfficeHour;
    } else if (this.opsStatus === OpsSecurityOpsReviewStatus.failedTest) {
      return this.labels.scheduleTechOfficeHour;
    }
    return '';
  }
  get showSecondLookOppties() {
    return (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) && this.opsStatus === OpsSecurityOpsReviewStatus.processingOps;
  }
  get showExpiredSecurityReviewOppties() {
    return (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) && this.opsStatus === OpsSecurityOpsReviewStatus.expired;
  }
  get expiredSRContactInfoLink() {
    return i18nStore.getState().i18n.securityReviewSubmission.expiredSRContactInfoLink({
      LINK: `/${SECURITY_REVIEW_EDITOR_ROUTE}?${upsertQueryParams(['step', '1'])}`
    });
  }
  get showWhatWillHappenNow() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      if (this.opsStatus !== OpsSecurityOpsReviewStatus.pass) {
        return true;
      }
    }
    return false;
  }
  get reviewStatusTitle() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      if (this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec) {
        return this.labels.submissionReturned;
      }
      if (this.opsStatus === OpsSecurityOpsReviewStatus.failedTest) {
        return this.labels.submissionFailed;
      }
      if (this.opsStatus === OpsSecurityOpsReviewStatus.expired) {
        return this.labels.submissionHasExpired;
      }
      if (this.opsStatus === OpsSecurityOpsReviewStatus.pass) {
        return this.labels.submissionPassed;
      }
    }
    return this.labels.submissionHasBeenSent;
  }
  get reviewStatusSubtitle() {
    if (this.srStatus === PartnerSecurityReviewStatus.submitted || this.srStatus === PartnerSecurityReviewStatus.reSubmitted) {
      if (this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps || this.opsStatus === OpsSecurityOpsReviewStatus.returnedProdSec) {
        return this.labels.submissionReturnedSubtitle;
      }
      if (this.opsStatus === OpsSecurityOpsReviewStatus.failedTest) {
        return i18nStore.getState().i18n.securityReviewSubmission.submitFailedSubtitle({
          NUMBER: this.submissionCount
        });
      }
      if (this.opsStatus === OpsSecurityOpsReviewStatus.expired) {
        return this.labels.submissionExpiredSubtitle;
      }
      if (this.opsStatus === OpsSecurityOpsReviewStatus.pass) {
        return this.labels.submitedPassSubtitle;
      }
    }
    return this.labels.learnNextSteps;
  }
  get feedbackCategories() {
    var _this$feedbackItem;
    return (_this$feedbackItem = this.feedbackItem) === null || _this$feedbackItem === void 0 ? void 0 : _this$feedbackItem.feedback;
  }
  get missingEnvironmentActions() {
    const actions = [];
    const missingEnvItems = this.feedbackCategories.invalidCredentialsMissingEnvironment;
    if (!missingEnvItems) {
      return actions;
    }
    if (missingEnvItems.invalidExpiredOrgCredentials) {
      actions.push({
        title: this.labels.missingCredentialsActions.invalidExpiredOrgCredentialsTitle,
        detail: this.labels.missingCredentialsActions.invalidExpiredOrgCredentialsDetail,
        additionalFeedback: missingEnvItems.invalidExpiredOrgCredentialsDetail
      });
    }
    if (missingEnvItems.missingAuthenticationWebApp) {
      actions.push({
        title: this.labels.missingCredentialsActions.missingAuthenticationWebAppTitle,
        detail: this.labels.missingCredentialsActions.missingAuthenticationWebAppDetail,
        additionalFeedback: missingEnvItems.missingAuthenticationWebAppDetail
      });
    }
    if (missingEnvItems.missingCredentialsApiOnly) {
      actions.push({
        title: this.labels.missingCredentialsActions.missingCredentialsApiOnlyTitle,
        detail: this.labels.missingCredentialsActions.missingCredentialsApiOnlyDetail
      });
    }
    if (missingEnvItems.missingCredentialsPackage) {
      actions.push({
        title: this.labels.missingCredentialsActions.missingCredentialsPackageTitle,
        detail: this.labels.missingCredentialsActions.missingCredentialsPackageDetail
      });
    }
    if (missingEnvItems.missingMobileAppLinks) {
      actions.push({
        title: this.labels.missingCredentialsActions.missingMobileAppLinksTitle,
        detail: this.labels.missingCredentialsActions.missingMobileAppLinksDetail
      });
    }
    if (missingEnvItems.missingMarketingCloudEnvironment) {
      actions.push({
        title: this.labels.missingCredentialsActions.missingMarketingCloudEnvironmentTitle,
        detail: this.labels.missingCredentialsActions.missingMarketingCloudEnvironmentDetail
      });
    }
    if (missingEnvItems.credentialsIsSandbox) {
      actions.push({
        title: this.labels.missingCredentialsActions.credentialsIsSandboxTitle,
        detail: this.labels.missingCredentialsActions.credentialsIsSandboxDetail
      });
    }
    if (missingEnvItems.rdpCredentialsRequired) {
      actions.push({
        title: this.labels.missingCredentialsActions.rdpCredentialsRequiredTitle,
        detail: this.labels.missingCredentialsActions.rdpCredentialsRequiredDetail
      });
    }
    actions.forEach(generateKeyForIterable);
    return actions;
  }
  get missingDocs() {
    const actions = [];
    const missingDocs = this.feedbackCategories.missingIncompleteDocumentation;
    if (!missingDocs) {
      return actions;
    }
    if (missingDocs.missingCheckmarxScanReport) {
      actions.push({
        title: this.labels.missingDocumentationActions.missingCheckmarxScanReportTitle,
        detail: this.labels.missingDocumentationActions.missingCheckmarxScanReportDetail
      });
    }
    if (missingDocs.missingWebAppScans) {
      actions.push({
        title: this.labels.missingDocumentationActions.missingWebAppScansTitle,
        detail: this.labels.missingDocumentationActions.missingWebAppScansDetail,
        additionalFeedback: missingDocs.missingWebAppScansDetail
      });
    }
    if (missingDocs.missingWebAppScanFalsePositiveDoc) {
      actions.push({
        title: this.labels.missingDocumentationActions.missingWebAppScanFalsePositiveDocTitle,
        detail: this.labels.missingDocumentationActions.missingWebAppScanFalsePositiveDocDetail
      });
    }
    if (missingDocs.missingCheckmarxFalsePositiveDoc) {
      actions.push({
        title: this.labels.missingDocumentationActions.missingCheckmarxFalsePositiveDocTitle,
        detail: this.labels.missingDocumentationActions.missingCheckmarxFalsePositiveDocDetail
      });
    }
    if (missingDocs.missingApiDocumentation) {
      actions.push({
        title: this.labels.missingDocumentationActions.missingApiDocumentationTitle,
        detail: this.labels.missingDocumentationActions.missingApiDocumentationDetail,
        additionalFeedback: missingDocs.missingApiDocumentationDetail
      });
    }
    if (missingDocs.missingUsageDocumentation) {
      actions.push({
        title: this.labels.missingDocumentationActions.missingUsageDocumentationTitle,
        detail: this.labels.missingDocumentationActions.missingUsageDocumentationDetail
      });
    }
    if (missingDocs.missingMcEnvironmentInstructions) {
      actions.push({
        title: this.labels.missingDocumentationActions.missingMcEnvironmentInstructionsTitle,
        detail: this.labels.missingDocumentationActions.missingMcEnvironmentInstructionsDetail
      });
    }
    actions.forEach(generateKeyForIterable);
    return actions;
  }
  get orgOrPackageIssues() {
    const actions = [];
    const issues = this.feedbackCategories.issueOrgPackage;
    if (!issues) {
      return actions;
    }
    if (issues.identityChallengeEnabled) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.identityChallengeEnabledTitle,
        detail: this.labels.orgOrPackageIssueAction.identityChallengeEnabledDetail
      });
    }
    if (issues.packagingOrg) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.packagingOrgTitle,
        detail: this.labels.orgOrPackageIssueAction.packagingOrgDetail
      });
    }
    if (issues.managedPackageNotInstalled) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.managedPackageNotInstalledTitle,
        detail: this.labels.orgOrPackageIssueAction.managedPackageNotInstalledDetail
      });
    }
    if (issues.incorrectVersionInstalled) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.incorrectVersionInstalledTitle,
        detail: this.labels.orgOrPackageIssueAction.incorrectVersionInstalledDetail,
        additionalFeedback: issues.incorrectVersionInstalledDetail
      });
    }
    if (issues.unmanagedExpiredBeta) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.unmanagedExpiredBetaTitle,
        detail: this.labels.orgOrPackageIssueAction.unmanagedExpiredBetaDetail
      });
    }
    if (issues.extraPackagesInstalled) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.extraPackagesInstalledTitle,
        detail: i18nStore.getState().i18n.securityReviewSubmission.orgOrPackageIssueAction.extraPackagesInstalledDetail({
          LINK: `/${SECURITY_REVIEW_EDITOR_ROUTE}?${upsertQueryParams(['step', '3'])}`
        }),
        additionalFeedback: issues.extraPackagesInstalledDetail
      });
    }
    if (issues.packageInstalledInFreeDevOrg) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.packageInstalledInFreeDevOrgTitle,
        detail: this.labels.orgOrPackageIssueAction.packageInstalledInFreeDevOrgDetail,
        additionalFeedback: issues.packageInstalledInFreeDevOrgDetail
      });
    }
    if (issues.packageInstalledInTrialOrg) {
      actions.push({
        title: this.labels.orgOrPackageIssueAction.packageInstalledInTrialOrgTitle,
        detail: this.labels.orgOrPackageIssueAction.packageInstalledInTrialOrgDetail,
        additionalFeedback: issues.packageInstalledInTrialOrgDetail
      });
    }
    actions.forEach(generateKeyForIterable);
    return actions;
  }
  get showFeedback() {
    return this.opsStatus === OpsSecurityOpsReviewStatus.returnedOps && this.feedbackCategories;
  }
  get showChallengeRaised() {
    return this.challengeRaised && this.opsStatus === OpsSecurityOpsReviewStatus.processingOps && this.srStatus === PartnerSecurityReviewStatus.reSubmitted;
  }
  get formattedChallengeDate() {
    return formatDate(this.challenge.challengeDate);
  }
  get showNextButton() {
    return canResubmit(this.hasFalsePositiveDocument, this.opsStatus);
  }
  get showFailedSubmissionContainer() {
    return isApiSolutionType(this.solutionTechnology) || this.solutionTechnology === 'force/Package';
  }
  get showFalsePositives() {
    return this.opsStatus === OpsSecurityOpsReviewStatus.failedTest && (this.solution.technology === 'force/Package' || isApiSolutionType(this.solution.technology));
  }
  get opportunitiesClass() {
    if (this.showFalsePositives || this.opsStatus === OpsSecurityOpsReviewStatus.expired) {
      return 'slds-col slds-size--1-of-2 slds-p-right_medium';
    }
    return 'slds-col slds-size--3-of-4 slds-p-right_medium';
  }
  goToReviewAndSubmit() {
    navigate(`/${SECURITY_REVIEW_EDITOR_ROUTE}?${upsertQueryParam('step', `status`)}`);
  }
  goToStep4() {
    navigate(`/${SECURITY_REVIEW_EDITOR_ROUTE}?${upsertQueryParam('step', `4`)}`);
  }
  goToStep3() {
    navigate(`/${SECURITY_REVIEW_EDITOR_ROUTE}?${upsertQueryParam('step', `3`)}`);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SecurityReviewSubmission, {
  publicProps: {
    srStatus: {
      config: 0
    },
    opsStatus: {
      config: 0
    },
    srDate: {
      config: 0
    },
    submissionCount: {
      config: 0
    },
    feedbackItem: {
      config: 0
    },
    challengeRaised: {
      config: 0
    },
    challenge: {
      config: 0
    },
    partnerWaitingReason: {
      config: 0
    },
    hasFalsePositiveDocument: {
      config: 0
    },
    solutionTechnology: {
      config: 0
    },
    solution: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["images", "labels", "sharedLabels", "stepLabels", "STATUS_DATA"]
});
const __lwc_component_class_internal = _registerComponent(SecurityReviewSubmission, {
  tmpl: _tmpl,
  sel: "appx-security-review-submission",
  apiVersion: 62
});
export default __lwc_component_class_internal;